<script setup lang="ts">
  interface Props {
    direction?: string
    color?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    direction: 'left',
    color: '#004564',
  })

  function getIcon() {
    switch (props.direction) {
      case 'left':
        return 'fa-regular fa-chevron-left'
      case 'right':
        return 'fa-regular fa-chevron-right'
      case 'up':
        return 'fa-regular fa-chevron-up'
      case 'down':
        return 'fa-regular fa-chevron-down'
    }
  }
  function getColor() {
    if (props.color === 'transparent') {
      // now one can let the icon disappear without complex
      // position calculations of neighbouring elements
      return 'text-transparent'
    }
    return `text-[${props.color}]`
  }
</script>
<template>
  <font-awesome-icon :icon="getIcon()" :class="getColor()"> </font-awesome-icon>
</template>
